export default "__VITE_ASSET__JYvwpjkB__"